import React from 'react';
import { PARTNER_COLORS } from '../constants';

export const PartnerSteps = ({ steps }) => (
  <ol className="space-y-0 max-w-2xl mx-auto">
    {steps.map((step, index) => (
      <li key={step.title} className="relative flex gap-6 pb-10 last:pb-0">
        {index < steps.length - 1 && (
          <span
            className="absolute left-5 top-12 bottom-0 w-px"
            style={{ backgroundColor: PARTNER_COLORS.border }}
            aria-hidden
          />
        )}
        <span
          className="flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center text-sm font-black text-white z-10"
          style={{ backgroundColor: PARTNER_COLORS.navy }}
        >
          {index + 1}
        </span>
        <div className="pt-1">
          <h3 className="text-lg font-bold mb-1" style={{ color: PARTNER_COLORS.navy }}>
            {step.title}
          </h3>
          {step.description && (
            <p className="text-[15px] leading-relaxed" style={{ color: PARTNER_COLORS.textMuted }}>
              {step.description}
            </p>
          )}
        </div>
      </li>
    ))}
  </ol>
);
